import { render, staticRenderFns } from "./SelectSession.vue?vue&type=template&id=bd3bf9fa"
import script from "./SelectSession.vue?vue&type=script&lang=ts"
export * from "./SelectSession.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports